import instance from "../../utils/instance";

class ProcessService {
    async getDictionaries() {
        return await instance.get('/oa/form/workflowConfig/GetDictionaries');
    }
    async getNodes(id) {
        return await instance.post('/wf/form/workflowConfig/GetNodes',{id});
    }
    async saveCondition(type,workflowNode,filter,nextStepNode,description) {
        return await instance.post('/wf/form/workflowConfig/saveCondition',{
            type: type,
            workflowNode: workflowNode,
            filter: filter,
            nextStepNode: nextStepNode,
            description: description
        });
    }
    async delNode(ids) {
        return await instance.post('/wf/form/workflowConfig/DeleteNode',{
            ids: ids
        });
    }
    async saveNodes(node,workflowTemplateId) {
        let workflowTemplate = {optionRequired:"1",summaryFields:[]}
        return await instance.post('/wf/form/node/saveNodes', {
            data: JSON.stringify(node),
            workflowTemplateId:workflowTemplateId,
            workflowTemplate: JSON.stringify(workflowTemplate)
        });
    }

    async create(workflowDefinitionId, dataId, attachmentId) {
        return await instance.post('/api/process/instance', {
            workflowDefinitionId, dataId, attachmentId
        });
    }

    async getVersion(formName) {
        return await instance.post('/wf/form/workflowConfig/getVersion', {
            formName
        });
    }


}

export default new ProcessService();